import { ReactNode } from 'react'

export type galleryPanelImage = {
    url: string
    alt: string
}

export enum PDPReactQueryKeys {
    ProductData = 'product-data',
    AlsoBoughtPDP = 'also-bought-products-pdp',
    AlsoBoughtCart = 'also-bought-products-cart',
    Similars = 'similars',
    SponsoredAd = 'sponsored-ad',
    Complementaries = 'complementaries',
    Wishlist = 'wishlist',
    Comments = 'comments',
    CommentsImages = 'comments-images',
    SnappPay = 'snapp-pay',
}

export interface IconedDetailsType {
    icon?: React.ReactElement
    text: string | JSX.Element | ReactNode
    hasToast: boolean
    toastOnClick?: () => void
    toastIcon?: React.ReactElement
    subText?: string | ReactNode
    tooltipIcon?: ReactNode
    tooltipText?: string | ReactNode
}

export enum ProductRecommendationTypes {
    complementary = 'complementary',
    similar = 'similar',
    alsoBought = 'also-bought',
    sponsoredAds = 'sponsored-ads',
}

export interface VariantPricingType {
    basePrice: number
    effectivePrice: number
    discountPercent: number
    isSalable: boolean
}
